import { clamp01, formatWeight } from '../lib/format.js';

export interface ScoreBarProps {
  label: string;
  /** 后端的 0–1 分量原值（前端不做任何计算，只做百分比展示） */
  value: number;
  /** 该分量的权重（0–1，来自 DEFAULT_WEIGHTS / 后端说明） */
  weight?: number;
  hint?: string;
}

/** 四项分量条：显示分量百分比（+ 可选权重），不做任何分数换算。 */
export function ScoreBar({ label, value, weight, hint }: ScoreBarProps) {
  const percent = Math.round(clamp01(value) * 100);
  return (
    <div className="score-bar">
      <div className="score-bar-head">
        <span className="score-bar-label">{label}</span>
        {typeof weight === 'number' ? <span className="score-bar-weight">权重 {formatWeight(weight)}</span> : null}
        <span className="score-bar-value">{percent}%</span>
      </div>
      <div className="score-bar-track" role="img" aria-label={`${label} ${percent}%`}>
        <div className={percent < 40 ? 'score-bar-fill low' : 'score-bar-fill'} style={{ width: `${percent}%` }} />
      </div>
      {hint !== undefined ? <span className="card-sub">{hint}</span> : null}
    </div>
  );
}